export default __webpack_public_path__ + "static/media/q9_step2_5.5c3b8f79.png";